import { Routes } from '@angular/router';

import { canActivateApp } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () => import('./feature/auth/auth.component').then((m) => m.AuthComponent),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./feature/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [canActivateApp],
  },
  {
    path: 'repository',
    loadChildren: () => import('./feature/repositories/repositories.module').then(m => m.RepositoriesModule),
    canActivate: [canActivateApp],
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  }
];
